import React, { useCallback } from 'react'
import { Flex, Text, BoostCalculator } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import history from 'routerHistory'
import { Path } from 'config/constants/paths'
import { setEditingFarmboost } from 'state/farmBoost/useEditingFarmboost'
import styled from 'styled-components'

const Wrapper = styled(Flex)`
  padding: 2px;
  gap: 8px;
  align-items: center;
  cursor: pointer;
`

const LinkText = styled(Text)`
  text-decoration: underline;
`

interface BoostCalculatorLinkProps {
  color?: string
  farmId?: number
}

const BoostCalculatorLink: React.FC<BoostCalculatorLinkProps> = ({ color, farmId }) => {
  const { t } = useTranslation()
  const onClick = useCallback(() => {
    setEditingFarmboost({ selectedBoostFarmIds: [farmId] })
    history.push(Path.BOOST_CALCULATOR)
  }, [farmId])

  return (
    <Wrapper onClick={onClick}>
      <BoostCalculator fill={color} />
      <LinkText color={color}>{t('Simulate your boost calculation')}</LinkText>
    </Wrapper>
  )
}

export default BoostCalculatorLink
